import { readAuthToken, clearAuthToken } from './authToken'
const AUTH_BASE_URL = import.meta.env.VITE_AUTH_URL || 'https://auth.dev.vammo.com'
const AUTH_VALIDATE_ENDPOINT = import.meta.env.VITE_AUTH_VALIDATE_ENDPOINT?.trim() || ''

function buildUrl(baseUrl, endpoint = '') {
  const normalizedBase = baseUrl.replace(/\/$/, '')
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`

  if (!endpoint) return normalizedBase
  return `${normalizedBase}${normalizedEndpoint}`
}

export async function authRequest(endpoint = '', options = {}) {
  const { handleAuthErrorManually, ...fetchOptions } = options
  const token = readAuthToken()

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...fetchOptions.headers,
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await fetch(buildUrl(AUTH_BASE_URL, endpoint), {
    ...fetchOptions,
    headers,
  })

  if (!response.ok) {
    if (response.status === 401 && !handleAuthErrorManually) {
      clearAuthToken()
    }

    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return response
}

export async function validateToken() {
  if (!AUTH_VALIDATE_ENDPOINT) {
    return true
  }

  await authRequest(AUTH_VALIDATE_ENDPOINT, {
    method: 'GET',
    handleAuthErrorManually: true,
  })

  return true
}
